/* eslint-disable camelcase */
import React from "react";
import ReactDOM from "react-dom";

import { SearchProvider } from "@elastic/react-search-ui";

import searchConnector from "../config/searchConnector";
import azureSearchSettings from "../config/azureSearchSettings";

import SearchResultsPage from "../components/SearchResultsPage/SearchResultsPage";

import nameOfSearch from "../constants/nameOfSearch";

const searchConfig = {
  debug: false,
  apiConnector: searchConnector,
  initialState: {
    resultsPerPage: 10,
  },
  autocompleteQuery: {
    suggestions: {
      filters: [
        {
          field: "type",
          type: "any",
          values: ["Capabilities", "Events", "Resources"],
        },
      ],
      top: 5,
    },
  },
  searchQuery: {
    // For each particular search page we may have individual set of facets.
    // Valid facet config properties you can find here:
    // https://docs.microsoft.com/en-us/rest/api/searchservice/search-documents#facetstring-zero-or-more
    // Remove business segments: business_segments: { count: 30 },
    facets: {
      type: { count: 30 },
      industries: { count: 30 },
      domains: { count: 30 },
      locations: { count: 30 },
      topical_areas: { count: 60 },
      created_date: { interval: "day" },
    },
    // filters: [
    //   {
    //     field: "type",
    //     type: "any",
    //     values: ["Capabilities", "Events", "Articles", "Resources", "Pages"],
    //   },
    // ],
  },
  alwaysSearchOnInitialLoad: true,
};

// Sorting options should be set directly for each sorter component
// and taken from the available for sorting Azure search fields.
// see Azure search definition: https://ffwagency.atlassian.net/wiki/spaces/L3HAR/pages/1821082063/Microsoft+Azure+Search
// const sortOptions = [
//   {
//     name: "Relevance",
//     value: "",
//     direction: "",
//   },
//   {
//     name: "Create Date",
//     value: "created_date",
//     direction: "desc",
//   },
// ];

// Show facets only if chosen category.
// Works only with radio types facets.
const dynamicHiddenFacets = {
  facetName: "type",
  items: [
    {
      type: "Articles",
      facets: ["created_date", "topical_areas"],
    },
    {
      type: "Events",
      facets: ["created_date", "business_segments"],
    },
    {
      type: "Capabilities",
      facets: ["locations", "topical_areas"],
    },
    {
      type: "Solutions",
      facets: ["locations", "topical_areas"],
    },
  ],
};

// Also need to add to hidden these facets by defaults.
const mainFacetsToHide = [
  "locations",
  "created_date"
];

// Is needed for correct reset filter, use it with mainFacetsToHide.
// On click All in facets, remove all facets from request except this one.
// For clear hidden facets from request.
const alwaysShowingFacets = ["domains", "industries"];

// Incase we have individual set of facets
// we should configure widget for each.
// https://github.com/elastic/search-ui/blob/master/ADVANCED.md#facet
const facetsConfig = {
  type: {
    label: "Results",
    filterType: "any",
    view: "SingleRadioFacet",
    weight: 1,
  },
  industries: {
    label: "Industries",
    filterType: "any",
    view: "MultiCheckboxFacet",
    weight: 2,
    labelsWeight: azureSearchSettings.facetLabelsWeight.industries,
  },
  domains: {
    label: "Domains",
    filterType: "any",
    view: "MultiCheckboxFacet",
    weight: 3,
    labelsWeight: azureSearchSettings.facetLabelsWeight.domains,
  },
  locations: {
    label: "Locations",
    filterType: "all",
    view: "SingleSelectFacet",
    weight: 4,
  },
  topical_areas: {
    label: "Solutions",
    filterType: "any",
    view: "MultiCheckboxFacet",
    weight: 5,
    labelsWeight: azureSearchSettings.facetLabelsWeight.topical_area,
    showMore: {
      initialShowings: 7,
    },
  },
  business_segments: {
    label: "Business Segments",
    filterType: "any",
    view: "MultiCheckboxFacet",
    weight: 6,
    labelsWeight: azureSearchSettings.facetLabelsWeight.segments_sectors,
  },
  created_date: {
    label: "Date",
    fieldLabel: "From",
    fieldName: "dateFacetFrom",
    filterType: "any",
    view: "DateFacet",
    weight: 7,
  },
};

const listingPageHero = {
  props: {
    title: "Search",
    theme: "default",
    searchForm: true,
  },
  formConfig: {
    inputPlaceholder: "Search L3Harris",
    inputName: "search-hero-search",
    inputId: "search-hero-search",
  },
};

const extraClass = "global";

export default function SearchResultsPageContainer() {
  return ReactDOM.createPortal(
    <SearchProvider config={searchConfig}>
      <SearchResultsPage
        facetsConfig={facetsConfig}
        listingPageHero={listingPageHero}
        resultListTitle="Search results"
        typeOfSearch={nameOfSearch.global}
        mainFacetsToHide={mainFacetsToHide}
        dynamicHiddenFacets={dynamicHiddenFacets}
        alwaysShowingFacets={alwaysShowingFacets}
        showSuggestions
        showTags
        extraClass={extraClass}
      />
    </SearchProvider>,
    document.getElementById("SearchResultsPageComponent")
  );
}
